import { instance } from "../../Utils/Api";

export const getInvoiceData = (external_id) => {
  return (dispatch) => {
    instance
      .get(
        `${process.env.REACT_APP_API_URL}/switching/api/v2/invoice/${external_id}`
        // `${process.env.REACT_APP_API_URL}/switching/api/v1/payment/invoice?external_id=${external_id}`
      )
      .then((res) => {
        dispatch({ type: "GET_INVOICE", payload: res.data.data });
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.data?.message === 'Token Expired') {
          dispatch({ type: "GET_INVOICE_EXPIRED", payload: err?.response?.data });
        } else {
          dispatch({ type: "GET_INVOICE_ERROR", payload: err?.response?.data });
        }
        console.log(err);
      });
  };
};
